var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 2.33301C18.63 2.33301 23.334 7.03701 23.334 12.833C23.334 18.629 18.63 23.333 12.834 23.333C7.03798 23.333 2.33398 18.629 2.33398 12.833C2.33398 7.03701 7.03798 2.33301 12.834 2.33301ZM12.834 20.9997C17.3455 20.9997 21.0007 17.3445 21.0007 12.833C21.0007 8.32034 17.3455 4.66634 12.834 4.66634C8.32132 4.66634 4.66732 8.32034 4.66732 12.833C4.66732 17.3445 8.32132 20.9997 12.834 20.9997ZM22.7332 21.0825L26.0337 24.3818L24.3828 26.0327L21.0835 22.7322L22.7332 21.0825Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f0893055ce4be62ceb6616f22738c2ad.svg";
export { ForwardRef as ReactComponent };